import React from 'react';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="flex min-h-screen">
      {/* Left side - Image for desktop, hidden on mobile */}
      <div className="hidden md:flex md:w-1/2 items-center justify-center p-8">
        <img 
          src="/lovable-uploads/welcome-back.png" 
          alt="Welcome back" 
          className="object-contain max-h-[75%]"
        />
      </div>
      
      {/* Right side - Auth content */}
      <div className="w-full bg-gray-100 md:w-1/2 flex flex-col items-center justify-center p-8">
        {/* Logo - Shown on both mobile and desktop */}
        <div className="mb-8 w-full max-w-[200px] mx-auto">
          <img 
            src="/lovable-uploads/ca9986fa-ca51-473a-952a-b52aa082d052.png" 
            alt="Logo" 
            className="w-full"
          />
        </div>
        
        {/* Auth content */}
        <div className="w-full max-w-md">
          {children}
        </div>
      </div>
    </div>
  );
};
